import CheckIcon from "../assets/images/CheckIcon"
import DoubleCheck from "../assets/images/DoubleCheck"

const Pricing = () => {
    const content = [
        {
            id: 1,
            title: "Never Break Your Flow",
            content: "Your favorite sounds continue to play in the background, even when your screen is off."
        },
        {
            id: 2,
            title: "Your Practice, Anywhere",
            content: "Take your peace on the go. Download all Yoga lessons and soothing sounds to play offline, perfect for travel or digital detox."
        },
        {
            id: 3,
            title: "Pure Immersion",
            content: "Experience crystal clear tranquility. Access our entire library of high quality, premium sounds, crafted for deeper relaxation and focus."
        },
        {
            id: 4,
            title: "Advanced Growth",
            content: "Unlock advanced Yoga lessons taught by expert instructors, guiding you to new levels of strength, flexibility, and mindfulness."
        },
    ]
    return (
        <div className="w-full h-full relative bg-bannerPricing bg-cover bg-no-repeat bg-center">
            <div className="w-full h-full relative lg:container pt-[120px] space-y-4 max-lg:px-4 ">
                <div className="max-lg:h-[calc(100%-80px)] max-lg:overflow-y-scroll">
                    <p className="text-white font-saira text-[80px] max-lg:text-[32px] font-light">Your Journey, <span className="font-extrabold">Your Price</span></p>
                    <div className="backdrop-blur-sm">
                        <p className="font-saira text-white text-[32px] font-bold ">Free Plan: <span className="font-light">All the basic</span></p>
                    </div>
                    <div className="lg:flex items-center lg:gap-x-8 w-[80%] max-lg:w-full max-lg:space-y-2">
                        <div className="py-4 px-2 rounded-3xl bg-[#FFFFFF26] bg-[#000000={() => border-l-[1.5px] border-white backdrop-blur-[27.6] items-center justify-center gap-x-2 min-w-[300px] h-[48px] lg:flex hidden">
                            <p className="text-white font-sf text-[14px] font-bold">GO PREMIUM </p>
                            <DoubleCheck />
                        </div>
                        <div className="flex-1 h-[2px] bg-white relative">
                            <div className="lg:absolute lg:left-2/3 lg:-translate-x-1/2 lg:bottom-full text-white font-saira font-extrabold text-[80px] max-lg:hidden">$2 <span className="font-normal text-[16px]">/Month</span></div>
                        </div>
                        <div className="max-lg:block hidden text-white font-saira font-extrabold text-[80px] text-center">$2 <span className="font-normal font-sf text-[16px]">/Month</span></div>
                        <div className="py-4 px-2 rounded-3xl bg-[#FFFFFF26] bg-[#000000={() => border-l-[1.5px] border-white backdrop-blur-[27.6] items-center justify-center gap-x-2 min-w-[300px] h-[48px] max-lg:flex hidden">
                            <p className="text-white font-sf text-[14px] font-bold">GO PREMIUM </p>
                            <DoubleCheck />
                        </div>
                    </div>
                    <div className="lg:w-[45%] max-lg:w-full grid grid-cols-2 gap-8 mt-8">
                        {content.map((v) => {
                            return (
                                <div className="lg:col-span-1 max-lg:col-span-full px-3 py-4 rounded-3xl bg-[#00000026] backdrop-blur-[50] space-y-4">
                                    <div className="flex items-center gap-x-2">
                                        <p className="text-[32px] font-bold font-saira text-white">{v.title}</p>
                                        <div className="w-6 h-6 rounded-full flex items-center justify-center bg-[#94DE1D]">
                                            <CheckIcon />
                                        </div>
                                    </div>
                                    <p className="text-white font-sf text-[16px] font-normal">{v.content}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Pricing